export default "__VITE_ASSET__94950531__"